"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const splitio_1 = require("@splitsoftware/splitio");
const enums_1 = require("./enums");
const constants_1 = require("./constants");
/**
 * Returns the appropriate split SDK key based on the passed in environment
 * @param environment - determined in the app and passed in, used to determine which SDK key to use
 */
const getClientSdkKey = (environment) => {
    if (environment === enums_1.Environment.PROD) {
        return constants_1.SPLIT_CLIENT_SIDE_SDK_KEY_PROD;
    }
    if (environment === enums_1.Environment.STAGING) {
        return constants_1.SPLIT_CLIENT_SIDE_SDK_KEY_STAGING;
    }
    return constants_1.SPLIT_CLIENT_SIDE_SDK_KEY_DEV;
};
/**
 * Creates a split factory based on provided params
 * @param environment - determined in the app and passed in, used to determine which SDK key to use
 * @param splitUserId - determined in the app and passed in, used as the Split user identifier for evaluations
 */
const createSplitFactoryClient = (environment, splitUserId) => {
    const factory = (0, splitio_1.SplitFactory)({
        core: {
            authorizationKey: getClientSdkKey(environment),
            key: splitUserId,
        },
        startup: {
            readyTimeout: 1.5, // 1.5 sec
        },
    });
    return factory.client();
};
exports.default = createSplitFactoryClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdG9yeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zcGxpdC9mYWN0b3J5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsb0RBQXNEO0FBRXRELG1DQUFzQztBQUN0QywyQ0FJcUI7QUFFckI7OztHQUdHO0FBQ0gsTUFBTSxlQUFlLEdBQUcsQ0FBQyxXQUF3QixFQUFVLEVBQUU7SUFDekQsSUFBSSxXQUFXLEtBQUssbUJBQVcsQ0FBQyxJQUFJLEVBQUU7UUFDbEMsT0FBTywwQ0FBOEIsQ0FBQztLQUN6QztJQUNELElBQUksV0FBVyxLQUFLLG1CQUFXLENBQUMsT0FBTyxFQUFFO1FBQ3JDLE9BQU8sNkNBQWlDLENBQUM7S0FDNUM7SUFDRCxPQUFPLHlDQUE2QixDQUFDO0FBQ3pDLENBQUMsQ0FBQztBQUVGOzs7O0dBSUc7QUFDSCxNQUFNLHdCQUF3QixHQUFHLENBQzdCLFdBQXdCLEVBQ3hCLFdBQW1CLEVBQ0csRUFBRTtJQUN4QixNQUFNLE9BQU8sR0FBd0IsSUFBQSxzQkFBWSxFQUFDO1FBQzlDLElBQUksRUFBRTtZQUNGLGdCQUFnQixFQUFFLGVBQWUsQ0FBQyxXQUFXLENBQUM7WUFDOUMsR0FBRyxFQUFFLFdBQVc7U0FDbkI7UUFDRCxPQUFPLEVBQUU7WUFDTCxZQUFZLEVBQUUsR0FBRyxFQUFFLFVBQVU7U0FDaEM7S0FDSixDQUFDLENBQUM7SUFDSCxPQUFPLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQztBQUM1QixDQUFDLENBQUM7QUFFRixrQkFBZSx3QkFBd0IsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../src/split/factory.ts